module.exports = __webpack_public_path__ + "img/check-circle 2.ac460324.png";